import axios from "axios";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { API_BASE_URI, PROD_LOCATION } from "./../constants/index";
import Order from "./orderApi";

// const history= useHistory()
// Set up default config for http requests here

// Please have a look at here `https://github.com/axios/axios#request-config` for the full list of configs

const baseURL = API_BASE_URI;
function axiosCreate() {
  var token = JSON.parse(localStorage.getItem("USER_TOKEN"));

  var axiosClient = axios.create({
    baseURL: baseURL,
    timeout: 300000,
    headers: {
      "content-type": "application/json",
      Authorization: token ? `Bearer ${token}` : null,
    },
    // when read object stringify to url
    paramsSerializer: (params) => queryString.stringify(params),
  });
  axiosClient.interceptors.response.use(
    (response) => {
      if (response) {
        console.log(response.request.responseURL);
      }
      if (response && response.data) {
        return response.data;
      }

      return response;
    },
    (error) => {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        return error.response.data;
      } else if (error.request) {
        console.log(error.request);
        return error.request;
      } else {
        console.log("Error", error.message);
        return error.message;
      }
    }
  );
  return axiosClient;
}

// const baseURL = "http://localhost:3000";

export const GET = async (path, params, data) => {
  // console.log(data);
  let url = path;

  if (params && params.length > 0) {
    for (let i = 0; i < params.length; i++) {
      url += `/${params[i]}`;
    }
  }
  const dataNew = {
    source: PROD_LOCATION || null,
    ...data,
  };

  let response = await axiosCreate().get(url, {
    params: dataNew,
  });
  if (response && response?.meta && response?.meta?.statusCode === 401) {
    // Order.logOutUser();
    localStorage.clear();
    window.location.replace("/login");
  }
  return response;
};

export const POST = async (path, { ...params } = {}) => {
  let url = path + `?source=${PROD_LOCATION || ""}`;

  const response = await axiosCreate().post(url, {
    ...params,
  });

  if (response && response?.meta && response?.meta?.statusCode === 401) {
    // Order.logOutUser();
    localStorage.clear();
    window.location.replace("/login");
  }
  return response;
};

export const PATCH = async (path, params, { ...data } = {}) => {
  let url = path;
  if (params && params.length > 0) {
    for (let i = 0; i < params.length; i++) {
      url += `/${params[i]}`;
    }
  }
  let response = await axiosCreate().patch(url, {
    ...data,
  });
  if (response && response?.meta && response?.meta?.statusCode === 401) {
    // Order.logOutUser();
    localStorage.clear();
    window.location.replace("/login");
  }
  return response;
};

export const DELETE = async (path, params) => {
  // console.log(data);
  let url = path;
  if (params && params.length > 0) {
    for (let i = 0; i < params.length; i++) {
      url += `/${params[i]}`;
    }
  }
  if (response && response?.meta && response?.meta?.statusCode === 401) {
    // Order.logOutUser();
    localStorage.clear();
    window.location.replace("/login");
  }
  let response = await axiosCreate().delete(url);
  return response;
};
